export class EditUserDto {
  username: string
  firstName: string
  lastName: string
  displayName: string
  email: string
  contactNumber: string

  constructor (attributes?) {
    if (attributes) {
      this.username = attributes.username
      this.displayName = attributes.displayName
      this.email = attributes.email
      this.contactNumber = attributes.contactNumber
      this.firstName = attributes.firstName
      this.lastName = attributes.lastName
    }
  }
}
